module.exports = __webpack_public_path__ + "static/media/sunset.e294eef3.ogg";